import dayjs from 'dayjs'
export const CATEGORIES = [
  'Brand',
  'Shop',
  'Online Shop',
  '重要なお知らせ',
  'キャンペーン',
]
export const CATEGORY_MAP = [
  { id: 'newsall', label: 'ALL' },
  { id: 'brandnews', label: CATEGORIES[0] },
  { id: 'shopnews', label: CATEGORIES[1] },
  { id: 'onlineshopnews', label: CATEGORIES[2] },
  { id: 'importantnews', label: CATEGORIES[3] },
  { id: 'campaignnews', label: CATEGORIES[4] },
]

export class Article {
  constructor(item) {
    this.blog = item.blog.handle
    this.id = item.id ? item.id.toString() : ''
    this.image = item.image
    this.publishedAt = new Date(item.published_at)
    this.tags = this.setTags(item.tags)
    this.title = item.title
    this.url = item.url || `/blogs/${this.blog}/${item.handle}`
  }

  get publishedAtText() {
    return dayjs(this.publishedAt).format('YYYY.M.D')
  }

  setTags(tags) {
    const tagsArray = Array.isArray(tags)
      ? tags
      : tags.split(',').map((tag) => tag.trim())

    return tagsArray.filter((tag) =>
      CATEGORIES.map((category) => category.toUpperCase()).includes(
        tag.toUpperCase()
      )
    )
  }

  static getIdFromTag(tag) {
    const category = Object.values(CATEGORY_MAP).find((c) => {
      return c.label.toUpperCase() === tag.toUpperCase()
    })
    return category && category.id
  }
}
